import React from "react";
import classnames from "classnames";

const colors = ["white", "green", "blue", "purple", "black"];
class Process_Button extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        let nextButtonState =
            nextProps.buttonState && nextProps.buttonState.toLowerCase();
        if (nextButtonState == "success" || nextButtonState == "failure") {
            return setTimeout(() => {
                if (typeof this.props.resetState === "function") {
                    return this.props.resetState();
                }
            }, 3000);
        }
    }

    render() {
        let buttonClass;
        let colorClass;
        let extraClass;
        let iconButtonClass;
        let ref;
        let status;
        if (this.props.buttonState) {
            status = this.props.buttonState.toLowerCase();
        } else {
            status = "initial";
        }
        colorClass = "";
        if (colors.indexOf(this.props.color) >= 0) {
            colorClass = this.props.color;
        }

        buttonClass = classnames(
            "button",
            "button-process",
            this.props.iconClass,
            colorClass,
            status,
            this.props.extraClass,
            {
                "button-icon": this.props.iconButton && status == "initial"
            }
        );

        return (
            <div className="process-button-wrapper">
                <button
                    onClick={this.props.callback}
                    className={buttonClass}
                    type="submit"
                >
                    <span>{this.props.buttonText}</span>
                </button>
            </div>
        );
    }
}

export default Process_Button;
